import { MediaLibraryFileModel } from '../../../../models/sales-funnel';
import { OfferItem, OfferPaymentTypeModel } from '../../offer/models/offer';
import {
  CourseAIBasedCreationInput,
  CourseCreationInput,
} from '../../product/models/course';
import { SystemProcessLoadingStatus } from 'src/app/models/global-classes';

export enum ProductTypeStatusEnum {
  active = 'active',
  soon = 'soon',
}

export class ProductType {
  id: number;
  name: string;
  enum: 'manual' | 'ai';
  // svgIcon: string;
  iconName: string;
  isRecommended?: boolean;
  description?: string;
  subDescription?: string;
  productFeatures?: { title: string }[];
  status: ProductTypeStatusEnum;
}

export class ProductWizardData {
  productType: ProductType;
  courseInput?: CourseAIBasedCreationInput;
  temp: any;
}

export class ProductCreationInput {
  name: string = '';
  shortDescription: string = '';
  description?: string = '';
  image?: MediaLibraryFileModel[];
  image_id?: number[];
  payment_type?: OfferPaymentTypeModel; //Same one used in creating offers
}
